<template>
    <div class="textbox">
        <label>{{label}}</label>
        <InputText placeholder="" 
         :class="{'p-invalid': isError}"
          v-model="value" 
          :disabled="disabled"
          :required="required"
           />
    </div>
</template>  
<script>

export default {
    props: ["modelValue",'required', 'disabled', 'label'],
    emits: ["update:modelValue"],
    components: {

    },
    data() {
        return {
            value :'',
            valueError:false,
           
        }
    },
    Service: null,
    EFormService: null,
    created() {
        this.value = this.modelValue

   
    },
    watch: {
            modelValue: function () {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            },
            value: function (newVal) {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
            },
          },
    computed: {
        isError() {
        return  !this.disabled && (!this.value || this.valueError==true)      ;
        },
    },
 
}
</script>
  
  